// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3DHtk","approved":"Status_approved__dXs8o","rejected":"Status_rejected__1mASS","expired":"Status_expired__2Aph2","label":"Status_label__36RXE"};